<template>
  <div class="container">
    <div class="main" >
        <div class="navi">
            <span class="close"><span class="icon-arrow-left" @click="goBack()"></span></span>
            <div class="top-title">加入我们</div>
            <span></span>
        </div>
        <div class="logo"><img src="../../../assets/img/index/logohf.svg"></div>
        <div class="core">
            <h2>加入我们</h2>
            <div>
            欢迎对生活服务行业感兴趣的伙伴加入到家<br>
            <br>
            如果你可以胜任以下工作岗位：<br>
            客服运营 / 轿车司机 / 卡车司机 / 搬家师傅 / 保洁师 / 仓库管理<br>
            <br>
            欢迎随时投递简历，联系我们：<a href="mailto:admin@daojia.com.au">admin@daojia.com.au</a><br>
            <div class="hint">(点击邮箱地址，立即发送邮件)</div><br>

            <div>或联系微信号：<span class="color-orange">daojia0422928229</span></div>
            </div>
        </div>
    </div>

  </div>
</template>

<script>
import qs from 'qs'
import anime from 'animejs';

export default {
  name: 'index',
  data () {
    return {
    }
  },
  methods: {

    goBack: function() {
        this.$router.push('/service/joinus');
    },
    sleep (time) {
      return new Promise((resolve) => setTimeout(resolve, time));
    },
  },
  created: function () {
    document.querySelector("html").classList.add("service-joinus-bg");
    if(this.data.username==""&&localStorage.member_name){
        this.data.username = localStorage.member_name;
    }
    if(this.data.userphone==""&&localStorage.member_phone){
        this.data.userphone = localStorage.member_phone;
    }
  },
  destroyed() {
    document.querySelector("html").classList.remove("service-joinus-bg");
  }
}
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../../../assets/css/base.scss";
.main{
    padding:0 10px;
}
.navi{
    display: flex;
    justify-content:space-between;
    padding:0 0 0 0;
    position:fixed;
    top:0;
    left:0;
    width:100%;
    background:rgba(255, 255, 255, 0.9);
    z-index:999;
    span{
        flex: 1;
    }
    div{
        flex:2;
    }
    .close{
        text-align:left;
        font-size:1em;
        .icon-arrow-left{
            margin-right:12px;
            margin-top:12px;
            display:inline-block;
        }
    }
    .icon-arrow-left{
        padding-left:12pt;
    }
    .top-title{
        font-size:0.5em;
        line-height:3.2em;
        color:#444;
        vertical-align:top;
        display:inline-block;
        text-align:center;
    }
}

.container{
  padding-bottom:60px;
}

.container /deep/ .weui-label{
    width:90px;
}

.container /deep/ .weui-cell__ft .qty span{
    font-size:1em;
}

.core{
  background:#f6f6f6;
  border-radius:4px;
  h2{
    padding: 14px 14px 20px 14px;
    text-align:center;
  }
  padding:20px 20px 40px 20px;
  text-align:center;
  a{
      color:#fe9567;
      font-size:1.2em;
  }
}

.logo{
  margin:10vh 0 2vh 6vw;
  img{
    width:46%;
  }
}

.title-sub{
  color: #fff;
  font-size: 0.8em;
  text-align: left;
  margin-bottom:5vh;
}
.park-assist{
    text-align:center;
    color:#fe9567;
}
.hint{
    color:#999;
    margin-top:10px;
    font-size:0.9em;
}


</style>



// WEBPACK FOOTER //
// src/pages/service/form/recruit.vue